<template>
    <div>
        <template v-if="! episodes.length && ! episodeModal.isAudioFileUploading()">
            <p>No Episodes to display.</p>
        </template>

        <template v-else>
            <episodes-list-order
                :value="order"
                :show="show"
                @change="onOrderChange"
            />

            <ul class="episodes-list">
                <transition
                    name="fade"
                    mode="out-in"
                >
                    <episodes-list-item-uploading
                        v-if="episodeModal.isAudioFileUploading()"
                        :episode="addEpisodeModal.episode"
                        :show="show"
                    />
                </transition>

                <episodes-list-item
                    v-for="episode in episodes"
                    :key="episode.id"
                    :episode="episode"
                    :show="show"
                />
            </ul>

            <div class="controll-container flex">
                <paginate
                    v-if="showPagination"
                    :value="page"
                    :page-count="totalPages"
                    :click-handler="onPageChange"
                    :prev-text="''"
                    :next-text="''"
                    :class="[{ 'has-navigation': showPaginationNavigation } ,'pagination']"
                    :active-class="'is-active'"
                    :prev-link-class="'pagination-arrow pagination-prev'"
                    :next-link-class="'pagination-arrow pagination-next'"
                    :hide-prev-next="showPaginationNavigation"
                    :first-last-button="showPaginationNavigation"
                    :first-button-text="''"
                    :last-button-text="''"
                    :break-view-class="'pagination-decorator'"
                />
            </div>
        </template>
    </div>
</template>
<script>
import { mapState } from 'vuex';
import Paginate from 'vuejs-paginate';
import EpisodesListItem from './EpisodesListItem';
import EpisodesListItemUploading from './EpisodesListItemUploading';
import EpisodesListOrder from './EpisodesListOrder';
import episodeModal from '@/utils/episodeModal';

export default {
    components: {
        Paginate,
        EpisodesListItem,
        EpisodesListItemUploading,
        EpisodesListOrder,
    },

    props: {
        show: {
            type: [Object, Boolean],
            default: () => ({}),
        },

        episodes: {
            required: true,
            type: Array,
        },

        order: {
            required: true,
            type: Object,
        },

        page: {
            required: true,
            type: Number,
        },
    },

    data: () => ({
        episodeModal,
    }),

    computed: {
        ...mapState({
            totalPages: state => state.episode.totalPages,
            addEpisodeModal: state => state.UIState.addEpisodeModal,
        }),

        /**
         * Indicated whether show pagination or not.
         *
         * @returns {boolean} Show pagination or not.
         */
        showPagination() {
            return 1 < this.totalPages;
        },

        /**
         * Indicated whether show pagination navigation or not.
         *
         * @returns {boolean} Show pagination navigation or not.
         */
        showPaginationNavigation() {
            return 3 < this.totalPages;
        },
    },

    methods: {
        /**
         * Handles order change event.
         *
         * @param  {object} order           Order data.
         */
        onOrderChange(order) {
            this.$emit('order-change', order);
        },

        /**
         * Handles page change event.
         *
         * @param  {number} page Selected page.
         */
        onPageChange(page) {
            this.$emit('page-change', page);
        },
    },
};
</script>
